/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const TooltipMessage = styled.div`
  padding: 4px;

  strong {
    display: block;
  }
`;

export const MessageTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  p {
    font-weight: 500;
  }
`;
